import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* iosで表示した際　画面下部にできる余白対策 */
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
// 画面のサイズ変動があった時に高さを再計算する
window.addEventListener('resize', setFillHeight)
// 初期化
setFillHeight()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})